import { useState } from 'react'
import { TextField, InputAdornment, SxProps, Theme } from '@mui/material'
import { CalendarMonth } from '@mui/icons-material'
import dayjs, { Dayjs } from 'dayjs'
import { ChooseEditMode } from '../simple/components/modal'
import { PickerProps } from '../simple/components/modal/picker/types'

type DateModalInputProps = {
  label: string
  defaultDate?: Dayjs | null
  getDate: (date: Dayjs) => void
  error?: boolean
  helperText?: string
  payload?: Omit<PickerProps, 'name'>
  title: string
  name: string
  timeZone?: string
  disabled?: boolean
  required?: boolean
  fullWidth?: boolean
  sx?: SxProps<Theme>
}

const DateModalInput = ({
  label,
  defaultDate,
  getDate,
  error,
  helperText,
  payload,
  title,
  name,
  timeZone = 'America/Mexico_City',
  disabled = false,
  required = false,
  fullWidth = true,
  sx,
}: DateModalInputProps) => {
  const [open, setOpen] = useState(false)
  const [, setIsToBiggerThanFrom] = useState(false)

  const handleOpen = () => {
    if (!disabled) setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleGetDate = (date: Dayjs) => {
    getDate(date)
    handleClose()
  }

  const displayValue = defaultDate
    ? dayjs(defaultDate).format('DD/MM/YYYY hh:mm A')
    : ''

  return (
    <>
      <TextField
        label={label}
        value={displayValue}
        onClick={handleOpen}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position='end'>
              <CalendarMonth />
            </InputAdornment>
          ),
        }}
        error={error}
        helperText={helperText}
        disabled={disabled}
        required={required}
        fullWidth={fullWidth}
        sx={sx}
      />
      {open && (
        <ChooseEditMode
          open={open}
          name={name}
          title={title}
          defaultValue={defaultDate}
            payload={{ ...payload, isSingleField: true }}
          timeZone={timeZone}
          setIsToBiggerThanFrom={setIsToBiggerThanFrom}
          cancel={handleClose}
          getFormat={handleGetDate}
        />
      )}
    </>
  )
}

export { DateModalInput }
